import { render, staticRenderFns } from "./Dataset_TLS_grid.vue?vue&type=template&id=9790f77a&scoped=true&"
import script from "./Dataset_TLS_grid.vue?vue&type=script&lang=js&"
export * from "./Dataset_TLS_grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9790f77a",
  null
  
)

export default component.exports